(() => {
  const pendingIsFresh = (pending, now) => !!pending && Number.isFinite(pending.at) && now >= pending.at && now - pending.at <= 30 * 60 * 1000;
  const attemptDecision = (pending, ready, now) => {
    if (!ready) return { emit: false, pending: null };
    if (pendingIsFresh(pending, now) && now - pending.at < 1500) return { emit: false, pending };
    return { emit: true, pending: { at: now } };
  };
  const confirmationDecision = (pending, serverConfirmed, ready, now) => {
    if (!ready || !serverConfirmed || !pendingIsFresh(pending, now)) return { emit: false, pending };
    return { emit: true, pending: null };
  };
  const canPublish = (shopify) => {
    try {
      return typeof shopify?.analytics?.publish === 'function' &&
        typeof shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function' &&
        shopify.customerPrivacy.analyticsProcessingAllowed() === true;
    } catch (_) { return false; }
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { pendingIsFresh, attemptDecision, confirmationDecision, canPublish };
  if (typeof document === 'undefined' || window.__amaQuoteMeasurementV1) return;
  const node = document.querySelector('[data-ama-quote-measurement]');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  let quote;
  try { quote = new URL(config.quoteUrl, window.location.origin); } catch (_) { return; }
  if (quote.origin !== window.location.origin || !quote.pathname.includes('/pages/')) return;
  window.__amaQuoteMeasurementV1 = true;
  const path = (value) => value.replace(/\/+$/, '');
  const key = 'ama:quote:pending:v1:' + path(quote.pathname);
  const readPending = () => {
    try { return JSON.parse(window.sessionStorage.getItem(key) || 'null'); } catch (_) { return null; }
  };
  const storePending = (pending) => {
    try {
      if (pending) window.sessionStorage.setItem(key, JSON.stringify(pending));
      else window.sessionStorage.removeItem(key);
      return true;
    } catch (_) { return false; }
  };
  const publish = (name, fields = {}) => {
    if (!canPublish(window.Shopify)) return false;
    try {
      const result = window.Shopify.analytics.publish(name, { version: 1, ...fields });
      if (result && typeof result.catch === 'function') result.catch(() => {});
      return result !== false;
    } catch (_) { return false; }
  };
  const consentWasDenied = () => {
    try {
      const api = window.Shopify?.customerPrivacy;
      return typeof api?.analyticsProcessingAllowed === 'function' && api.analyticsProcessingAllowed() === false;
    } catch (_) { return false; }
  };
  const root = () => document.querySelector('[data-ama-quote-measurement-root]');
  const checkConfirmation = () => {
    if (consentWasDenied()) { storePending(null); return; }
    if (path(window.location.pathname) !== path(quote.pathname)) return;
    const confirmed = !!root()?.querySelector('[data-ama-quote-success]');
    const decision = confirmationDecision(readPending(), confirmed, canPublish(window.Shopify), Date.now());
    if (!decision.emit || !storePending(null)) return;
    publish('ama:quote_form_confirmed', { form: 'native_quote' });
  };
  document.addEventListener('click', (event) => {
    if (!event.isTrusted || event.button > 0 || !canPublish(window.Shopify)) return;
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    let target;
    try { target = new URL(link.href, window.location.origin); } catch (_) { return; }
    if (target.origin !== quote.origin || path(target.pathname) !== path(quote.pathname)) return;
    const placement = link.closest('main') ? (config.pageType === 'product' ? 'product' : 'content')
      : link.closest('footer') ? 'footer' : link.closest('header') ? 'header' : 'content';
    publish('ama:quote_click', { placement });
  }, true);
  document.addEventListener('submit', (event) => {
    const form = root()?.querySelector('form');
    if (!form || event.target !== form || !canPublish(window.Shopify)) return;
    const decision = attemptDecision(readPending(), true, Date.now());
    if (!decision.emit) return;
    storePending(decision.pending);
    publish('ama:quote_attempt', { form: 'native_quote' });
  }, true);
  const ready = () => {
    checkConfirmation();
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
        if (!error) checkConfirmation();
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
  window.addEventListener('load', checkConfirmation, { once: true });
  document.addEventListener('visitorConsentCollected', checkConfirmation);
})();
